import { freeze } from 'rewire-core';
import { Modal }  from 'rewire-ui';

interface IConfirmationModelState {
  redirectTimeout: number;
  countdown:       number;
  progress:        number;
}

export class ConfirmationModel extends Modal<IConfirmationModelState> {
  constructor() {
    super(undefined, true);
  }

  reset() {
    freeze(() => {
      this.state.redirectTimeout = 8_000;
      this.state.countdown       = 8;
      this.state.progress        = 0;
    });
  }

  load(redirectTimeout?: number) {
    this.reset();
    if (redirectTimeout) {
      this.state.redirectTimeout = redirectTimeout;
      this.state.countdown       = Math.round(redirectTimeout / 1_000);
    }
  }

  get redirectTimeout(): number {
    return this.state.redirectTimeout;
  }

  get countdown(): number {
    return this.state.countdown;
  }

  get progress(): number {
    return this.state.progress;
  }

  decrementCountdown() {
    this.state.countdown = Math.max(this.countdown - 1, 0);
  }

  incrementProgress() {
    this.state.progress = Math.min(this.progress + ((500 / this.redirectTimeout) * 100), 100);
  }
}

const confirmationModel = new ConfirmationModel();
export default confirmationModel;
